/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Page_ThanksInputs */

const ja_contact_page_thanks = /** @type {(inputs: Contact_Page_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you!`)
};

const en_contact_page_thanks = /** @type {(inputs: Contact_Page_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you!`)
};

/**
* | output |
* | --- |
* | "Thank you!" |
*
* @param {Contact_Page_ThanksInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_page_thanks = /** @type {((inputs?: Contact_Page_ThanksInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Page_ThanksInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_page_thanks(inputs)
	return en_contact_page_thanks(inputs)
});